export default "__VITE_ASSET__28228994__"